<script setup lang="ts">
interface Props {
  size?: 'sm' | 'md' | 'lg'
  text?: string
}

const props = withDefaults(defineProps<Props>(), {
  size: 'md',
  text: '',
})

const sizeClasses = {
  sm: 'size-4',
  md: 'size-6',
  lg: 'size-8',
}

const paddingClasses = {
  sm: 'p-4',
  md: 'p-8',
  lg: 'p-16',
}
</script>

<template>
  <div class="flex items-center justify-center" :class="paddingClasses[props.size]">
    <div class="flex flex-col items-center gap-3">
      <UIcon
        name="svg-spinners:pulse-rings"
        class="text-primary-500" :class="[sizeClasses[props.size]]"
      />
      <p v-if="props.text" class="text-sm text-neutral-600 dark:text-neutral-400">
        {{ props.text }}
      </p>
    </div>
  </div>
</template>
